module.exports = __webpack_public_path__ + "img/5.b486c770.jpg";